// extracted by mini-css-extract-plugin
export var container = "timeline-subheader-module--container--ap+QJ";
export var sectiontitle = "timeline-subheader-module--sectiontitle--nXC0g";
export var sectiontext = "timeline-subheader-module--sectiontext--PcoKY";